import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import { handleUserLevelAccessPermissions, changeDateFormat } from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import titlesData from '../../../../titles.json';
import iipTitleData from '../../../../iip.json';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../.././../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { generalIndexReport, iipMiningReport, iipMiningReportCombined } from '../../../../Custom/IIPReport/Report/ReportExcel';




const IIPGeneralReport = () => {

    const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const [isDivision, setIsDivision] = useState(false);
    const [years, setYears] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [reportRows, setReportRows] = useState([]);
    const [reportMonths, setReportMonths] = useState([]);
    const [buttonAccess, setButtonAccess] = useState(false);
    const storedLanguage = localStorage.getItem('language');
    const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const MONTH_SHORT = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const config = getAuthHeaders();

  useEffect(() => {

    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)
    if(level.userLevel === "DIVISION LEVEL" && level.roles.includes("DIVADM")) {
      setIsDivision(true);
     }

    const startYear = 2014;
    const endYear = new Date().getFullYear();
    const yearsArray = [];
    for (let y = endYear; y >= startYear; y--) yearsArray.push(y);
    setYears(yearsArray);
   }, []);

  const FUTURE_MONTH_YEAR_MSG = 'Please select a valid month and year';

  const isFutureMonthYear = (monthIndex, yearVal) => {
    if (monthIndex === '' || monthIndex === null || monthIndex === undefined || yearVal === '' || yearVal === null || yearVal === undefined) {
      return false;
    }
    const y = Number(yearVal);
    const m = Number(monthIndex);
    if (!Number.isFinite(y) || !Number.isFinite(m)) return false;
    const now = new Date();
    const cy = now.getFullYear();
    const cm = now.getMonth();
    if (y > cy) return true;
    if (y < cy) return false;
    return m > cm;
  };

  const handleMonthChange = (e) => {
    const raw = e.target.value;
    const newMonth = raw === '' ? '' : Number(raw);
    if (newMonth !== '' && selectedYear !== '' && isFutureMonthYear(newMonth, selectedYear)) {
      toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
      return;
    }
    setSelectedMonth(newMonth);
  };

  const handleYearChange = (e) => {
    const raw = e.target.value;
    const newYear = raw === '' ? '' : Number(raw);
    if (selectedMonth !== '' && newYear !== '' && isFutureMonthYear(selectedMonth, newYear)) {
      toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
      return;
    }
    setSelectedYear(newYear);
  };

  /** 0-based col index → Excel letter (for merge range) */
  const getColumnLetterLocal = (colIndex) => {
    let s = '';
    let n = colIndex + 1;
    while (n > 0) {
      const r = (n - 1) % 26;
      s = String.fromCharCode(65 + r) + s;
      n = Math.floor((n - 1) / 26);
    }
    return s;
  };

  // Bold rows as per screenshot: sector headings + General Index
  const GENERAL_BOLD_FIRST_COL = [
    'MINING SECTOR',
    'ELECTRICITY SECTOR',
    'MANUFACTURING SECTOR',
    'GENERAL INDEX',
  ];

  const extractMonthArray = (data) =>
    data?.monthArray || data?.payload?.months || [];

  const extractMonthArrayPrevious = (data) =>
    data?.monthArrayPrevious || data?.payloadPrevious?.months || [];

  const parseNumeric = (val) => {
    if (val === null || val === undefined || val === '') return null;
    const n = Number(val);
    return Number.isFinite(n) ? n : null;
  };

  const getVariationMeta = (currentCell, referenceCell) => {
    const currentIndex = parseNumeric(currentCell?.['Index(I)']);
    const referenceIndex = parseNumeric(referenceCell?.['Index(I)']);
    if (currentIndex === null || referenceIndex === null) return { text: '', value: null };

    let variation = 0;
    if (referenceIndex === 0) {
      variation = currentIndex === 0 ? 0 : 100;
    } else {
      variation = ((currentIndex - referenceIndex) / referenceIndex) * 100;
    }
    return {
      text: `${variation.toFixed(2)}%`,
      value: variation,
    };
  };

  const buildNormalizedMonthRows = (groupCodes, months) => {
    if (!Array.isArray(groupCodes) || !Array.isArray(months) || months.length === 0) return [];

    const sectorLabels = new Set(['MINING SECTOR', 'ELECTRICITY SECTOR', 'MANUFACTURING SECTOR']);

    return groupCodes.map((item) => {
      const row = {
        'Industry and Item': item.item ?? item.Item ?? '',
        Weight: item.weight ?? item.Weight ?? '',
        Units: item.units ?? item.Units ?? '',
      };

      months.forEach((m) => {
        const cell = item[m] || {};
        row[m] = {
          'B.P.2011-12(Qty)': cell.BP ?? cell.bp ?? '',
          'C.P.(Qty)': cell.CP ?? cell.cp ?? '',
          'Index(I)': cell.Index ?? cell.index ?? cell.IndexI ?? '',
          'Index* Wt (IW)': cell.IndexWeight ?? cell.Index_Wt ?? cell.indexWeight ?? cell.Index_WT ?? '',
        };
      });

      // keep reference to sector labels if needed later
      row.__isSector = sectorLabels.has(row['Industry and Item']);
      return row;
    });
  };

  /** API nested shape: each row has objects under month keys */
  const hasNestedMonthShape = (groupCodes, months) => {
    if (!Array.isArray(groupCodes) || !groupCodes.length) return false;
    if (!Array.isArray(months) || !months.length) return false;
    const sample = groupCodes[0];
    return months.every((m) => sample && typeof sample[m] === 'object' && sample[m] !== null);
  };

  const transformGroupCodes = (arr) => (arr || []).map((item) => [
    item.item ?? item.Item ?? '',
    item.weight ?? item.Weight ?? '',
    item.units ?? item.Units ?? '',
    item.BP ?? item.BP201112 ?? '',
    item.CP ?? item.CP_QTY ?? '',
    item.Index ?? item.index ?? item.IndexI ?? '',
    item.IndexWeight ?? item.indexWeight ?? item.IndexWt ?? '',
  ]);

  const HEADER_COLUMNS = [
    'Industry and Item ( with code)', 'Weight', 'Units',
    'B.P.2011-12(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt (IW)'
  ];

  const getPeriodLabel = (p) => {
    if (p?.month && p?.year) return `${p.month} ${p.year}`;
    if (p?.fromDate && p?.toDate) {
      return p.fromDate === p.toDate ? String(p.fromDate) : `${p.fromDate}-${p.toDate}`;
    }
    return 'Report';
  };

  const buildGeneralBlock = (groupCodes) => ({
    yearColumn: HEADER_COLUMNS,
    headerEnglishColumns: ['', '', '', 'B.P.2011-12(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt (IW)'],
    excelRowData: transformGroupCodes(groupCodes),
    mergeRow: 1,
    monthGroupSizes: [4],
  });

  /** Multi-month: same layout as Mining — grouped headers, 4 sub-columns per month (BP, CP, Index, IndexWeight only). */
  const buildGeneralMultiMonthBlock = (groupCodes, months) => {
    const parseNumeric = (val) => {
      if (val === null || val === undefined || val === '') return null;
      const n = Number(val);
      return Number.isFinite(n) ? n : null;
    };

    const getIndexValue = (cell) =>
      cell?.Index ??
      cell?.index ??
      cell?.['Index(I)'] ??
      cell?.IndexI ??
      '';

    const getIndexVariationFromCurrent = (currentIndexRaw, referenceIndexRaw) => {
      const currentIndex = parseNumeric(currentIndexRaw);
      const referenceIndex = parseNumeric(referenceIndexRaw);
      if (currentIndex === null || referenceIndex === null) return '';
      if (referenceIndex === 0) {
        return currentIndex === 0 ? '0.00%' : '100.00%';
      }
      const variation = ((currentIndex - referenceIndex) / referenceIndex) * 100;
      return `${variation.toFixed(2)}%`;
    };

    // yearColumn first header row: group titles + empty placeholders to support merges
    const modifiedArray = [];
    for (let i = 0; i < months.length; i += 1) {
      if (i === 0) modifiedArray.push(months[i], '', '', ''); // 4 cols
      else modifiedArray.push(months[i], '', '', '', ''); // 5 cols (includes Variation %)
    }

    const yearColumn = ['Industry and Item ( with code)', 'Weight', 'Units', ...modifiedArray];

    const subCols = [];
    for (let i = 0; i < months.length; i += 1) {
      if (i === 0) {
        subCols.push('B.P.2011-12(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt (IW)');
      } else {
        subCols.push('B.P.2011-12(Qty)', 'C.P.(Qty)', 'Index(I)', 'Index* Wt (IW)', 'Variation %');
      }
    }
    const headerEnglishColumns = ['', '', '', ...subCols];

    // excelRowData: 3 fixed cols + month groups (4 cols for current month, 5 cols for others)
    const excelRowData = (groupCodes || []).map((item) => {
      const cells = [];
      const currentCell = item[months[0]] || {};
      const currentIndexRaw = getIndexValue(currentCell);

      months.forEach((m, mi) => {
        const cell = item[m] || {};
        const bp = cell.BP ?? cell.bp;
        const cp = cell.CP ?? cell.cp;
        const ix = getIndexValue(cell);
        const iw = cell.IndexWeight ?? cell.Index_Wt ?? cell.indexWeight ?? '';

        const bpVal = bp === '' || bp === null || bp === undefined ? '' : bp;
        const cpVal = cp === '' || cp === null || cp === undefined ? '' : cp;
        const ixVal = ix === '' || ix === null || ix === undefined ? '' : ix;
        const iwVal = iw === '' || iw === null || iw === undefined ? '' : iw;

        cells.push(bpVal, cpVal, ixVal, iwVal);

        if (mi !== 0) {
          const variationText = getIndexVariationFromCurrent(currentIndexRaw, ix);
          cells.push(variationText);
        }
      });

      return [
        item.item ?? item.Item ?? '',
        item.weight ?? item.Weight ?? '',
        item.units ?? item.Units ?? '',
        ...cells,
      ];
    });

    return {
      yearColumn,
      headerEnglishColumns,
      excelRowData,
      mergeRow: months.length,
      monthGroupSizes: months.map((_, idx) => (idx === 0 ? 4 : 5)),
    };
  };

  const downloadGeneralMultiMonthReport = async (groupCodes, payload, months) => {
    const block = buildGeneralMultiMonthBlock(groupCodes, months);
    const totalCols = block.yearColumn.length;
    const lastColLetter = getColumnLetterLocal(Math.max(1, totalCols) - 1);
    let headingYear = months[0] || 'Report';
    if (payload?.month && payload?.year) {
      headingYear = `${payload.month} ${payload.year}`;
    }
    await iipMiningReport({
      reportName: 'GENERAL INDEX',
      boldFirstColLabels: GENERAL_BOLD_FIRST_COL,
      mergeRow: months.length,
      monthGroupSizes: block.monthGroupSizes,
      fileName: `IIPGeneralIndexReport(${String(headingYear).replace(/\s+/g, '_')})`,
      fileType: 'xls',
      sheetName: 'IIPGeneralReport',
      firstRowMergeCells: `A1:${lastColLetter}1`,
      firstRowExportDate: changeDateFormat(new Date()),
      secondRowMergeCells: `A2:${lastColLetter}2`,
      secondRowText: 'ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH',
      thirdRowMergeCells: `A3:${lastColLetter}3`,
      thirdRowText: ' INDUSTRIAL PRODUCTION INDEX  U.P ',
      fourthRowMergeCells: `A4:${lastColLetter}4`,
      fourthRowText: 'General Index Report',
      fromDate: headingYear,
      toDate: headingYear,
      yearColumn: block.yearColumn,
      headerEnglishColumns: block.headerEnglishColumns,
      excelRowData: block.excelRowData,
    });
  };

  const buildSingleExcelPayload = (groupCodes, payload) => {
    const periodLabel = getPeriodLabel(payload);
    const safeFile = String(periodLabel).replace(/\s+/g, '_');
    return {
    fileName: `IIPGeneralIndexReport(${safeFile})`,
    reportType: `IIPGeneralIndexReport(${safeFile})`,
    fileType: 'xls',
    sheetName: 'IIPGeneralReport',
    firstRowMergeCells: "A1:G1",
    firstRowExportDate: changeDateFormat(new Date()),
    secondRowMergeCells: "A2:G2",
    secondRowText: `ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH`,
    thirdRowMergeCells: "A3:G3",
    thirdRowText: ` INDUSTRIAL PRODUCTION INDEX  U.P `,
    fourthRowMergeCells: "A4:G4",
    fourthRowText: `General Index Report`,
    firthRowMergeCells: "A5:G5",
    fifthRowText: `[${periodLabel}]`,
    fromDate: periodLabel,
    toDate: periodLabel,
    headerEnglishColumns: HEADER_COLUMNS,
    excelRowData: transformGroupCodes(groupCodes),
  };
  };

//handle excel sheet ***************
const handleGenerateExcel = () => {
  if (selectedMonth === '' || selectedYear === '') {
    toast.error('Please select month and year', messages.COLOR_RED);
    return;
  }
  if (isFutureMonthYear(selectedMonth, selectedYear)) {
    toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
    return;
  }

  showLoading(true);
  const month = MONTH_SHORT[Number(selectedMonth)];
  const year = String(selectedYear);
  const payload = { month, year };

  axios
    .post(`${API_URL}api/iipReports/HQReports/GeneralIndexReport`, payload, config)
    .then(async (response) => {
      const data = response.data?.data || response.data || {};
      const currentData = data.GroupCodesCurrent || data.GroupCodes || [];
      const currentPayload = { ...payload, ...(data.payloadCurrent || {}) };
      const previousRaw = data.GroupCodesPrevious ?? data.groupCodesPrevious;
      const previousData = Array.isArray(previousRaw) ? previousRaw : [];
      // API kabhi previous rows bhejta hai lekin payloadPrevious nahi — tab bhi combined / no false toast
      const previousPayloadMerged = data.payloadPrevious
        ? { ...payload, ...data.payloadPrevious }
        : { ...payload };

      const hasCurrent = Array.isArray(currentData) && currentData.length > 0;
      const hasPrevious = previousData.length > 0;

      const monthsCurrent = extractMonthArray(data);
      const monthsPrevious = extractMonthArrayPrevious(data);
      const monthsPrevEffective =
        monthsPrevious.length > 0 ? monthsPrevious : monthsCurrent;

      const useMultiCurrent = hasNestedMonthShape(currentData, monthsCurrent);
      const useMultiPrevious = hasNestedMonthShape(previousData, monthsPrevEffective);

      // Update on-screen table for "current" multi-month report
      if (useMultiCurrent && Array.isArray(monthsCurrent) && monthsCurrent.length > 0) {
        setReportMonths(monthsCurrent);
        setReportRows(buildNormalizedMonthRows(currentData, monthsCurrent));
      } else {
        setReportMonths([]);
        setReportRows([]);
      }

      if (hasCurrent && hasPrevious) {
        const headingYear = getPeriodLabel(currentPayload);
        try {
          if (useMultiCurrent && useMultiPrevious) {
            await iipMiningReportCombined({
              firstRowExportDate: changeDateFormat(new Date()),
              secondRowText: 'ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH',
              thirdRowText: ' INDUSTRIAL PRODUCTION INDEX  U.P ',
              fourthRowTextCurrent: `General Index Report (${headingYear})`,
              current: buildGeneralMultiMonthBlock(currentData, monthsCurrent),
              previous: buildGeneralMultiMonthBlock(previousData, monthsPrevEffective),
              reportName: 'GENERAL INDEX',
              boldFirstColLabels: GENERAL_BOLD_FIRST_COL,
              fileName: `IIPGeneralIndexReport_Combined(${String(headingYear).replace(/\s+/g, '_')})`,
              fileType: 'xls',
              sheetName: 'IIPGeneralReport',
            });
          } else {
            await iipMiningReportCombined({
              firstRowExportDate: changeDateFormat(new Date()),
              secondRowText: 'ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH',
              thirdRowText: ' INDUSTRIAL PRODUCTION INDEX  U.P ',
              fourthRowTextCurrent: `General Index Report (${headingYear})`,
              current: buildGeneralBlock(currentData),
              previous: buildGeneralBlock(previousData),
              reportName: 'GENERAL INDEX',
              boldFirstColLabels: GENERAL_BOLD_FIRST_COL,
              fileName: `IIPGeneralIndexReport_Combined(${String(headingYear).replace(/\s+/g, '_')})`,
              fileType: 'xls',
              sheetName: 'IIPGeneralReport',
            });
          }
        } catch (err) {
          console.error('Excel generation error:', err);
          toast.error('Report download failed.', messages.COLOR_RED);
        }
      } else if (hasCurrent) {
        try {
          if (useMultiCurrent && monthsCurrent.length > 0) {
            await downloadGeneralMultiMonthReport(currentData, currentPayload, monthsCurrent);
          } else {
            await generalIndexReport(buildSingleExcelPayload(currentData, currentPayload));
          }
        } catch (err) {
          console.error('Excel generation error:', err);
          toast.error('Report download failed.', messages.COLOR_RED);
        }
      } else if (hasPrevious) {
        try {
          if (useMultiPrevious && monthsPrevEffective.length > 0) {
            await downloadGeneralMultiMonthReport(previousData, previousPayloadMerged, monthsPrevEffective);
          } else {
            await generalIndexReport(buildSingleExcelPayload(previousData, previousPayloadMerged));
          }
        } catch (err) {
          console.error('Excel generation error:', err);
          toast.error('Report download failed.', messages.COLOR_RED);
        }
        toast.info('Current period data not found.', messages.COLOR_RED);
      } else {
        toast.info('No data found for the selected period.', messages.COLOR_RED);
      }
      showLoading(false);
    })
    .catch((error) => {
      console.error('API Error:', error);
      toast.error(error?.response?.data?.message || 'Failed to fetch report.', messages.COLOR_RED);
      showLoading(false);
    });
};
 

  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
            <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.GENERAL_INDEX_REPORT : iipTitleData.en.GENERAL_INDEX_REPORT }} />
           </h4>
            <div className="row align-items-center">
              {isDivision && (
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                  <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                </div>
              )}

              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>Month</label>
                <select
                  className="form-select form-select-sm"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                >
                  <option value="">Select month</option>
                  {MONTH_NAMES.map((name, index) => (
                    <option key={index} value={index}>{name}</option>
                  ))}
                </select>
              </div>

              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>Year</label>
                <select
                  className="form-select form-select-sm"
                  value={selectedYear}
                  onChange={handleYearChange}
                >
                  <option value="">Select year</option>
                  {years.length > 0 ? years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                  )) : (
                    <option value={selectedYear}>{selectedYear}</option>
                  )}
                </select>
              </div>

              <div className="col-xl-2 col-lg-4 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

    {/* On-screen report table (same layout + variation colors as Mining) */}
    {reportRows.length > 0 && reportMonths.length > 0 && (
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Industry and Item</th>
                  <th>Weight</th>
                  <th>Units</th>
                  {reportMonths.map((m, mi) => (
                    <th key={m} colSpan={mi === 0 ? 4 : 5} className="text-center align-middle">
                      {m}
                    </th>
                  ))}
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  {reportMonths.flatMap((m, mi) => {
                    const ths = [
                      <th key={`${m}-bp`}>B.P.(Qty)</th>,
                      <th key={`${m}-cp`}>C.P.(Qty)</th>,
                      <th key={`${m}-i`}>Index(I)</th>,
                      <th key={`${m}-iw`}>Index*Wt(IW)</th>,
                    ];
                    if (mi !== 0) ths.push(<th key={`${m}-var`}>Variation %</th>);
                    return ths;
                  })}
                </tr>
              </thead>
              <tbody>
                {(() => {
                  const seenBoldLabels = new Set();
                  return reportRows.map((row, idx) => {
                    const isSector = row.__isSector === true;
                    const rowLabel = (row['Industry and Item'] ?? '').trim();
                    const shouldBoldFirst =
                      GENERAL_BOLD_FIRST_COL.includes(rowLabel) && !seenBoldLabels.has(rowLabel);
                    if (shouldBoldFirst) seenBoldLabels.add(rowLabel);

                    return (
                      <tr key={`${rowLabel}-${idx}`}>
                        <td
                          style={{
                            fontWeight: shouldBoldFirst ? 700 : 400,
                            fontSize: shouldBoldFirst ? 11 : 10,
                          }}
                        >
                          {rowLabel}
                        </td>
                        <td>{row.Weight}</td>
                        <td>{row.Units}</td>
                        {reportMonths.flatMap((m, mi) => {
                          const cell = row[m] || {};
                          const currentCell = row[reportMonths[0]] || {};

                          const baseCells = ([
                            <td key={`${idx}-${m}-bp`}>{isSector ? '' : (cell['B.P.2011-12(Qty)'] ?? '')}</td>,
                            <td key={`${idx}-${m}-cp`}>{isSector ? '' : (cell['C.P.(Qty)'] ?? '')}</td>,
                            <td key={`${idx}-${m}-i`}>{cell['Index(I)'] ?? ''}</td>,
                            <td key={`${idx}-${m}-iw`}>{cell['Index* Wt (IW)'] ?? ''}</td>,
                          ]);

                          if (mi !== 0) {
                            const varMeta = getVariationMeta(currentCell, cell);
                            const v = varMeta.value;
                            const eps = 1e-9;
                            const isZero = v !== null && Math.abs(v) < eps;
                            const arrow = isZero ? '' : (v > 0 ? '▲ ' : '▼ ');
                            const color = v === null ? '' : isZero ? 'blue' : (v > 0 ? 'green' : 'red');
                            baseCells.push(
                              <td
                                key={`${idx}-${m}-var`}
                                style={{ color, fontWeight: v === null ? 'normal' : 600 }}
                              >
                                {varMeta.text ? `${arrow}${varMeta.text}` : ''}
                              </td>
                            );
                          }

                          return baseCells;
                        })}
                      </tr>
                    );
                  });
                })()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )}
  </>
  );
}

export default IIPGeneralReport
